import { render } from "./SimpleTableForSingleSelect.vue?vue&type=template&id=367c7cfc&scoped=true"
import script from "./SimpleTableForSingleSelect.vue?vue&type=script&lang=ts"
export * from "./SimpleTableForSingleSelect.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-367c7cfc"

export default script